// Default to a relative path so the same build works under any host that
// proxies /api/* to a Django origin (Netlify, nginx-on-edcat-server, the
// dev server via setupProxy.js, ...). Override with REACT_APP_API_BASE only
// when shipping a build that should hit an absolute URL.
export const BASE_URL = process.env.REACT_APP_API_BASE || '/api/edcat';
export const requestOptions = {
	method: 'GET',
	redirect: 'follow',
	// Force a fresh request every time. Random-ordered list endpoints set
	// Cache-Control: no-store on the response, but some browsers still serve
	// from disk cache for navigations; this guarantees we always go to the
	// network.
	cache: 'no-store'
};
